module.exports = __webpack_public_path__ + "static/masterClassGif-117c9deb514ec214d5be67dd28004309.gif";